import { getQueryParam } from 'services/queryParamsService';

const MODE = 'mode';
const POPUP_MODE = 'popup';

const PopupModeMessages = {
  OPEN_SUPPORT_CHAT: 'open_intercom_chat',
  UPGRADE_COMPLETE: 'upgrade_complete',
}

function sendMessage(type, data) {
  window.parent.postMessage(JSON.stringify({ type, data }), '*');
}

export const PopupModeService = {
  isPopupMode() {
    return getQueryParam(MODE) === POPUP_MODE;
  },
  openSupportChat(text) {
    sendMessage(PopupModeMessages.OPEN_SUPPORT_CHAT, text);
  },
  upgradeComplete() {
    sendMessage(PopupModeMessages.UPGRADE_COMPLETE);
  },
};
